import { StrictMode } from 'react';
import { allImages, localImages } from '@root';
import { APP_TOKEN_KEY, X_AUTH_HEADER } from '@root/constants';
import IntlProvider from '@root/providers/IntlProvider';
import { store } from '@root/store/store';
import { getStableClientId } from '@shared/lib';
import { RootProvider } from '@shared/providers';
import { setSharedConstants } from '@shared/store';
import { createRoot } from 'react-dom/client';
import 'normalize.css';
import 'react-toastify/dist/ReactToastify.css';
import './styles/global.scss';
import App from './App';

setSharedConstants({
  APP_TOKEN_KEY,
  X_AUTH_HEADER,
});

// Wait for custom fonts before first render; allImages uses CDN when VITE_CDN_URL is set.

// Create + persist the stable per-device client id at app open
// (TP-3863) — bet payloads reuse it instead of a fresh uuid per bet.
getStableClientId();

document.fonts.ready.then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <RootProvider
        images={allImages}
        localImages={localImages}
        intlWrapper={IntlProvider}
        store={store}
      >
        <App />
      </RootProvider>
    </StrictMode>
  );
});
